<template>
  <div class="card-guide">
    <div class="card-guide-body">
      <div class="d-flex justify-content-between">
        <span class="search">
          <label>
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.3335 3.16659C4.75617 3.16659 2.66683 5.25592 2.66683 7.83325C2.66683 10.4106 4.75617 12.4999 7.3335 12.4999C9.91083 12.4999 12.0002 10.4106 12.0002 7.83325C12.0002 5.25592 9.91083 3.16659 7.3335 3.16659ZM1.3335 7.83325C1.3335 4.51954 4.01979 1.83325 7.3335 1.83325C10.6472 1.83325 13.3335 4.51954 13.3335 7.83325C13.3335 11.147 10.6472 13.8333 7.3335 13.8333C4.01979 13.8333 1.3335 11.147 1.3335 7.83325Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.6284 11.1286C10.8887 10.8683 11.3108 10.8683 11.5712 11.1286L14.4712 14.0286C14.7315 14.289 14.7315 14.7111 14.4712 14.9714C14.2108 15.2318 13.7887 15.2318 13.5284 14.9714L10.6284 12.0714C10.368 11.8111 10.368 11.389 10.6284 11.1286Z"
                fill="#B3C2CB"
              />
            </svg>
            <input
              type="search"
              class="search-input"
              placeholder="Search Articles"
              v-model="searchStr"
            />
          </label>
        </span>
      </div>
      <div class="blogs" role="tablist">
        <b-card no-body>
          <b-table
            id="table-transition-example"
            :items="blogs"
            :fields="fields"
            striped
            small
            primary-key="a"
            :tbody-transition-props="transProps"
          >
            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(wordpressId)="row">
              <span v-if="row.item.blog && row.item.blog.wpId">{{
                row.item.blog.wpId
              }}</span>
              <span v-else>Not Assigned</span>
            </template>
            <template #cell(title)="row">
              <span v-if="row.item.blog && row.item.blog.title">{{
                row.item.blog.title
              }}</span>
              <span v-else>{{ row.item.doc.title }}</span>
            </template>
            <template #cell(img)="row">
              <img
                v-if="row.item.blog && row.item.blog.imgURL"
                :src="row.item.blog.imgURL"
                class="mr-3 blog-img"
              />
            </template>
            <template #cell(blogger)="row">
              <div class="text-center">
                <b-avatar
                  v-if="row.item.blogger && row.item.blogger.imgURL"
                  variant="info"
                  :src="row.item.blogger.imgURL"
                  class="mr-3"
                >
                </b-avatar>
                <div v-if="row.item.blogger && row.item.blogger.firstname">
                  {{
                    row.item.blogger.firstname + " " + row.item.blogger.lastname
                  }}
                </div>
              </div>
            </template>
            <template #cell(docURL)="row">
              <span class="ico">
                <svg
                  v-b-popover.top.hover="popupText"
                  @click="copytoClipboard(row.item.docURL)"
                  @mouseleave="changePopupText"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.33337 6.66683C6.96518 6.66683 6.66671 6.96531 6.66671 7.3335V13.3335C6.66671 13.7017 6.96518 14.0002 7.33337 14.0002H13.3334C13.7016 14.0002 14 13.7017 14 13.3335V7.3335C14 6.96531 13.7016 6.66683 13.3334 6.66683H7.33337ZM5.33337 7.3335C5.33337 6.22893 6.2288 5.3335 7.33337 5.3335H13.3334C14.4379 5.3335 15.3334 6.22893 15.3334 7.3335V13.3335C15.3334 14.4381 14.4379 15.3335 13.3334 15.3335H7.33337C6.2288 15.3335 5.33337 14.4381 5.33337 13.3335V7.3335Z"
                    fill="#B3C2CB"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.66663 1.99984C2.48981 1.99984 2.32025 2.07008 2.19522 2.1951C2.0702 2.32012 1.99996 2.48969 1.99996 2.6665V8.6665C1.99996 8.84332 2.0702 9.01288 2.19522 9.13791C2.32025 9.26293 2.48982 9.33317 2.66663 9.33317H3.33329C3.70148 9.33317 3.99996 9.63165 3.99996 9.99984C3.99996 10.368 3.70148 10.6665 3.33329 10.6665H2.66663C2.13619 10.6665 1.62748 10.4558 1.25241 10.0807C0.87734 9.70564 0.666626 9.19694 0.666626 8.6665V2.6665C0.666626 2.13607 0.87734 1.62736 1.25241 1.25229C1.62749 0.877217 2.13619 0.666504 2.66663 0.666504H8.66663C9.19706 0.666504 9.70577 0.877218 10.0808 1.25229C10.4559 1.62736 10.6666 2.13607 10.6666 2.6665V3.33317C10.6666 3.70136 10.3681 3.99984 9.99996 3.99984C9.63177 3.99984 9.33329 3.70136 9.33329 3.33317V2.6665C9.33329 2.48969 9.26305 2.32012 9.13803 2.1951C9.01301 2.07008 8.84344 1.99984 8.66663 1.99984H2.66663Z"
                    fill="#B3C2CB"
                  />
                </svg>
              </span>
            </template>
            <template #cell(spheres)="row">
              <svg
                v-if="row.item.doc.spheres.includes('s')"
                class="mr-1"
                height="31"
                viewBox="0 0 31 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959
                24.0604 0 15.5 0C6.93958 0 0 6.93959 0 15.5C0 24.0604 6.93958 31
                15.5 31Z"
                  fill="#557EFB"
                />
                <path
                  d="M16.8568 7.25651C16.7516 7.25492 16.6502 7.29588 16.5764 7.37083L14.5994 9.3367C14.5274 9.40868 14.4614 9.48604 14.395 9.56309C13.6597 8.95221 12.7373 8.60899 11.7789 8.60976H10.8973C10.6823 8.60976 10.5052 8.78694 10.5052 9.00196V10.5052H9.00191C8.78689 10.5052 8.61013 10.682 8.61013 10.897V11.7786C8.61021 12.0739 8.65073 12.3671 8.71363 12.6555C8.44879 12.8217 8.19786 13.01 7.97689 13.2314L7.3712 13.8371C7.2192 13.9891 7.2192 14.2391 7.3712 14.3911L9.36256 16.3828C9.4328 16.4531 9.50822 16.5171 9.58306 16.5816C8.95993 17.3204 8.60936 18.252 8.61013 19.2211V20.1026C8.61015 20.3176 8.78689 20.4944 9.00191 20.4944H10.5052V21.9977C10.5052 22.2127 10.6824 22.3898 10.8974 22.3898H11.7789C12.0865 22.3898 12.3914 22.3462 12.6912 22.2781C12.8553 22.5379 13.0405 22.7844 13.258 23.0017L13.8657 23.6252C13.9386 23.7001 14.0385 23.7426 14.1431 23.7434H14.1456C14.2491 23.7434 14.3487 23.7024 14.4221 23.6294L16.4001 21.6629V21.6627C16.4719 21.5906 16.5379 21.5134 16.6042 21.4363C17.3397 22.0475 18.2619 22.3907 19.2207 22.3899H20.1021C20.3172 22.3899 20.4943 22.2128 20.4943 21.9977V20.4945H21.9976C22.2127 20.4945 22.3894 20.3177 22.3894 20.1027V19.2208C22.3894 18.9255 22.3488 18.6325 22.2859 18.3442C22.5507 18.178 22.8013 17.9899 23.0223 17.7685L23.6283 17.1625C23.7804 17.0105 23.7804 16.7603 23.6283 16.6082L21.6369 14.6165C21.5667 14.5464 21.4913 14.4825 21.4165 14.418C22.0396 13.6792 22.3902 12.7477 22.3894 11.7787V10.8971C22.3894 10.6821 22.2127 10.5053 21.9976 10.5053H20.4943V9.00194C20.4943 8.78692 20.3172 8.60983 20.1021 8.60983H19.2207C18.9131 8.60986 18.6077 8.65337 18.308 8.72155C18.1442 8.46208 17.9596 8.21605 17.7425 7.99895L17.7406 7.99768L17.1329 7.37431C17.0601 7.29954 16.9602 7.25732 16.8558 7.25635L16.8568 7.25651ZM16.8489 8.20525L17.183 8.54787L17.1859 8.55072C18.4849 9.85272 18.4848 11.9568 17.1859 13.2589L16.8058 13.6389C16.5318 13.446 16.2213 13.317 15.8912 13.2591V12.7229C15.8912 11.7705 15.5541 10.8533 14.95 10.1199C15.0151 10.0417 15.0806 9.96392 15.1525 9.89192V9.89165L16.8489 8.20525ZM11.2887 9.39373H11.7782C13.6175 9.39563 15.1054 10.8837 15.1074 12.723V13.2616C14.2636 13.4116 13.5855 14.0165 13.3319 14.8326C12.1048 14.3109 11.2922 13.1198 11.2887 11.7786V11.7783V9.39373ZM19.2207 9.39373H19.7105V10.5052H19.2207C19.1198 10.5053 19.0191 10.5132 18.9186 10.5206C18.8849 10.1539 18.8001 9.79533 18.67 9.45102C18.8524 9.42046 19.0356 9.39378 19.2207 9.39373V9.39373ZM9.39369 11.2888H10.5049V11.7786C10.5049 11.8708 10.5121 11.9612 10.5183 12.0518C10.1505 12.0835 9.79054 12.1665 9.4448 12.2955C9.41791 12.1242 9.39381 11.9521 9.39373 11.7786L9.39369 11.2888ZM19.2207 11.2888H21.6055V11.7786C21.6036 13.6178 20.1158 15.1056 18.2766 15.1078H17.74C17.6822 14.7777 17.5536 14.467 17.3606 14.1929L17.74 13.8135V13.8132C18.4156 13.1413 18.826 12.2534 18.917 11.3072C19.0179 11.2979 19.119 11.289 19.2203 11.2889L19.2207 11.2888ZM10.6523 12.8262C10.9054 13.7741 11.4905 14.5876 12.2922 15.1452C11.5056 15.2281 10.7597 15.5294 10.1432 16.0297C10.0654 15.9651 9.98817 15.8999 9.9165 15.8285L8.20228 14.1139L8.53112 13.785C9.09703 13.2148 9.85237 12.8789 10.652 12.8262H10.6523ZM15.5053 13.9926C15.5587 13.9932 15.6119 13.9969 15.6647 14.0032C15.8056 14.0201 15.9437 14.0567 16.0748 14.111C16.5994 14.3282 17.0029 14.8248 17.0029 15.4997C17.001 16.3309 16.3309 17.0018 15.4997 17.003C14.8248 17.003 14.3279 16.5998 14.1106 16.0752C13.8933 15.5506 13.9595 14.9141 14.4366 14.437C14.7497 14.1239 15.1316 13.9877 15.5053 13.9926V13.9926ZM20.856 14.9699H20.8561C20.9338 15.0346 21.011 15.0997 21.0827 15.1711L22.7973 16.8854L22.4681 17.2145C21.9021 17.7846 21.1468 18.1207 20.3473 18.1734C20.0942 17.2256 19.509 16.4121 18.7074 15.8544C19.494 15.7715 20.2397 15.4702 20.8563 14.9699H20.856ZM12.7226 15.8918H12.7227H13.2589C13.3168 16.2219 13.4457 16.5324 13.6386 16.8064L13.2592 17.1861C12.5834 17.858 12.1729 18.7458 12.0819 19.6921C11.9809 19.7015 11.8797 19.7103 11.7782 19.7105H9.39369V19.221C9.39559 17.3819 10.8835 15.8941 12.7226 15.8918V15.8918ZM17.6673 16.1669C18.8946 16.6887 19.7072 17.8797 19.7105 19.2211V21.6059H19.2207C17.3814 21.604 15.8935 20.116 15.8914 18.2766V17.7381C16.7354 17.5882 17.4137 16.9831 17.6673 16.1669ZM14.1929 17.3607C14.467 17.5536 14.7776 17.6825 15.1078 17.7403V18.2766C15.1078 19.2289 15.4448 20.1459 16.0486 20.8793C15.9837 20.9576 15.9183 21.0355 15.8465 21.1076L14.1503 22.7944L13.8145 22.4498C13.8145 22.4501 13.8145 22.4491 13.8145 22.4495V22.4492V22.4489C12.5134 21.1478 12.5134 19.042 13.8145 17.7409L14.1929 17.3607ZM21.5544 18.7038C21.5813 18.8752 21.6054 19.0474 21.6055 19.2211V19.7105H20.4944V19.2211C20.4944 19.1287 20.4871 19.0382 20.4809 18.9475C20.8488 18.9159 21.2085 18.8328 21.5543 18.7038H21.5544ZM12.0806 20.479C12.1143 20.8456 12.1987 21.2042 12.3288 21.5485C12.1466 21.5791 11.9635 21.6059 11.7785 21.6059H11.2888V20.4944H11.7785C11.8794 20.4943 11.9801 20.4863 12.0806 20.4789V20.479Z"
                  fill="white"
                />
              </svg>
              <svg
                v-if="row.item.doc.spheres.includes('h')"
                class="mr-1"
                width="31"
                height="31"
                viewBox="0 0 31 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                  fill="#FF8C7D"
                />
                <path
                  d="M11.7163 7.92725C10.4068 7.92725 9.20456 8.45094 8.32717 9.40254C7.46019 10.343 6.98157 11.6289 6.98157 13.0251C6.98157 14.4615 7.51479 15.7744 8.66947 17.1677C9.70254 18.4142 11.1926 19.6848 12.9201 21.157C12.921 21.1577 12.922 21.1585 12.9229 21.1593C13.5122 21.6614 14.1799 22.231 14.8729 22.837C15.0462 22.9888 15.2686 23.072 15.4994 23.072C15.73 23.072 15.9527 22.9885 16.1258 22.837C16.8204 22.2295 17.4891 21.6595 18.0793 21.1566C19.8066 19.6845 21.2965 18.4139 22.3296 17.1673C23.4843 15.7741 24.0179 14.4615 24.0179 13.0251C24.0179 11.6289 23.5392 10.343 22.6722 9.40254C21.7949 8.45094 20.5925 7.92725 19.2831 7.92725C18.305 7.92725 17.4115 8.23585 16.6225 8.84606C16.2242 9.15407 15.863 9.53126 15.5441 9.97199C15.539 9.97904 15.5323 9.98476 15.5245 9.98871C15.5167 9.99267 15.5081 9.99473 15.4993 9.99473C15.4906 9.99473 15.482 9.99267 15.4742 9.98871C15.4665 9.98476 15.4597 9.97904 15.4545 9.97199C15.1358 9.53126 14.7747 9.15407 14.3766 8.84606C13.5876 8.23586 12.6941 7.92725 11.716 7.92725H11.7163ZM11.7163 8.82091C12.4902 8.82091 13.2031 9.06806 13.8299 9.55266C14.3887 9.98484 14.7755 10.5286 15.0026 10.9093C15.1085 11.0868 15.2933 11.1918 15.4997 11.1918C15.7061 11.1918 15.8909 11.0868 15.9968 10.9093C16.224 10.5286 16.6108 9.98484 17.1695 9.55266C17.7962 9.06806 18.5091 8.82091 19.283 8.82091C20.3381 8.82091 21.31 9.2429 22.0155 10.0081C22.7315 10.7849 23.1245 11.8567 23.1245 13.0251C23.1245 14.2586 22.6636 15.3649 21.6422 16.5974C20.6547 17.789 19.1921 19.0345 17.5004 20.4763C16.9078 20.9811 16.2364 21.5535 15.5347 22.1646C15.5245 22.1734 15.5116 22.1783 15.4981 22.1783C15.4847 22.1783 15.4717 22.1734 15.4616 22.1646C14.765 21.5556 14.0961 20.9849 13.5052 20.4814L13.5021 20.479C13.5011 20.4783 13.5001 20.4775 13.4992 20.4767C11.8074 19.0349 10.3445 17.789 9.35706 16.5975C8.33555 15.3649 7.87469 14.2586 7.87469 13.0252C7.87469 11.8568 8.26769 10.7849 8.98374 10.0082C9.68935 9.24293 10.661 8.82092 11.7162 8.82092L11.7163 8.82091Z"
                  fill="white"
                />
              </svg>
              <svg
                v-if="row.item.doc.spheres.includes('e')"
                class="mr-1"
                width="31"
                height="31"
                viewBox="0 0 31 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                  fill="#65EA82"
                />
                <path
                  d="M10.1106 21.1949C9.85899 21.1949 9.65503 20.9909 9.65503 20.7393V10.0889C9.65503 9.05258 10.4982 8.20947 11.5345 8.20947H20.8885C21.1401 8.20947 21.344 8.41348 21.344 8.6651V19.1446C21.344 19.3962 21.1401 19.6002 20.8885 19.6002C20.6368 19.6002 20.4328 19.3962 20.4328 19.1446V9.12073H11.5345C11.0006 9.12073 10.5663 9.55506 10.5663 10.0889V20.7393C10.5663 20.9909 10.3623 21.1949 10.1106 21.1949V21.1949Z"
                  fill="white"
                />
                <path
                  d="M20.8885 22.7901H11.7054C10.5748 22.7901 9.65503 21.8703 9.65503 20.7398C9.65503 19.6092 10.5748 18.6895 11.7054 18.6895H20.8885C21.1401 18.6895 21.344 18.8935 21.344 19.1451C21.344 19.3967 21.1401 19.6007 20.8885 19.6007H11.7054C11.0773 19.6007 10.5663 20.1117 10.5663 20.7398C10.5663 21.3679 11.0773 21.8788 11.7054 21.8788H20.8885C21.1401 21.8788 21.344 22.0828 21.344 22.3345C21.344 22.5861 21.1401 22.7901 20.8885 22.7901V22.7901Z"
                  fill="white"
                />
                <path
                  d="M20.8886 21.1954H11.7055C11.4538 21.1954 11.2499 20.9914 11.2499 20.7398C11.2499 20.4882 11.4538 20.2842 11.7055 20.2842H20.8886C21.1402 20.2842 21.3442 20.4882 21.3442 20.7398C21.3442 20.9914 21.1402 21.1954 20.8886 21.1954Z"
                  fill="white"
                />
                <path
                  d="M12.1611 19.6002C11.9094 19.6002 11.7054 19.3962 11.7054 19.1445V8.6651C11.7054 8.41348 11.9094 8.20947 12.1611 8.20947C12.4127 8.20947 12.6167 8.41348 12.6167 8.6651V19.1445C12.6167 19.3962 12.4127 19.6002 12.1611 19.6002Z"
                  fill="white"
                />
              </svg>
              <svg
                v-if="row.item.doc.spheres.includes('f')"
                class="mr-1"
                width="31"
                height="31"
                viewBox="0 0 31 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                  fill="#F6F28B"
                />
                <path
                  d="M11.226 8.40771C10.3024 8.41177 9.55279 9.15531 9.53763 10.0792H9.35966C8.42659 10.0792 7.6684 10.8333 7.66431 11.7664C7.66431 11.7665 7.66431 11.7666 7.66431 11.7666V20.8924C7.66431 20.8925 7.66431 20.8925 7.66431 20.8926C7.66839 21.8256 8.42237 22.5877 9.35948 22.5918H19.7737C20.6973 22.5877 21.4469 21.8441 21.4621 20.9202H21.64C22.5731 20.9202 23.3313 20.1661 23.3354 19.233C23.3354 19.233 23.3354 19.2329 23.3354 19.2328V10.107C23.3354 10.1069 23.3354 10.1068 23.3354 10.1068C23.3313 9.16996 22.5772 8.41181 21.6402 8.40772H11.226V8.40771ZM11.226 9.29902H11.2265H21.6403C22.0841 9.30298 22.4406 9.66321 22.4444 10.1073V12.0289L21.4652 13.2909V11.7666C21.4652 10.8334 20.7069 10.0792 19.7738 10.0792H10.4289C10.4437 9.64847 10.7918 9.3029 11.2261 9.29902H11.226ZM9.35948 10.9705H19.7737C20.2138 10.9705 20.5738 11.3229 20.5738 11.7666V14.0008C20.5183 14.0108 20.4625 14.0193 20.4105 14.0193H18.114C16.8385 14.0193 15.8019 15.056 15.8019 16.3315C15.8019 17.607 16.8384 18.6437 18.1139 18.6477H20.4063C20.4072 18.6477 20.4081 18.6477 20.4089 18.6477C20.4641 18.6447 20.5171 18.6383 20.5697 18.6325L20.5736 20.8925C20.5736 21.3363 20.2173 21.6965 19.7735 21.7004H9.35967H9.35921C8.91553 21.6965 8.55911 21.3363 8.55516 20.8924V11.7671V11.7666C8.55915 11.3268 8.91534 10.9705 9.35921 10.9705L9.35948 10.9705ZM22.4405 13.4856L22.4442 15.7621L21.2084 17.365C21.0186 17.6118 20.7219 17.7566 20.4099 17.7604H18.1143H18.1139C17.3277 17.7564 16.693 17.1215 16.693 16.3354C16.693 15.5494 17.3277 14.9146 18.1139 14.9106H20.4063C20.6876 14.9106 20.9652 14.8495 21.2186 14.727L21.219 14.7268C21.4886 14.6001 21.725 14.4084 21.9085 14.1718V14.1718L22.4405 13.4856ZM18.0504 15.8898C17.8055 15.8898 17.6048 16.0905 17.6048 16.3354C17.6048 16.5804 17.8055 16.7811 18.0504 16.7811H19.0055C19.2504 16.7811 19.4512 16.5804 19.4512 16.3354C19.4512 16.0905 19.2504 15.8898 19.0055 15.8898H18.0504ZM22.4443 17.219V19.2328C22.4402 19.6727 22.0841 20.0289 21.6402 20.0289H21.4651V18.3165C21.6315 18.2011 21.7833 18.0617 21.9118 17.906C21.9121 17.9056 21.9124 17.9052 21.9127 17.9048L22.4443 17.219Z"
                  fill="white"
                />
              </svg>
            </template>
            <template #cell(feedback)="row">
              <b-button
                :id="`popover-target-${row.item.id}`"
                size="sm"
                class="mt-2"
                style="background: transparent; border-style: none;"
              >
                <svg
                  width="42"
                  height="41"
                  viewBox="0 0 42 41"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.71739 30.3259C7.81248 29.9788 7.60407 29.4962 7.40518 29.1483C7.34352 29.0444 7.27633 28.9439 7.20391 28.8472C5.49805 26.2602 4.58884 23.2295 4.58895 20.1307C4.56042 11.2359 11.9362 4.01782 21.0568 4.01782C29.011 4.01782 35.6515 9.52825 37.2022 16.843C37.4349 17.9275 37.5526 19.0334 37.5532 20.1426C37.5532 29.0501 30.462 36.3815 21.3413 36.3815C19.8904 36.3815 17.9339 36.017 16.8666 35.7182C15.7992 35.4195 14.7334 35.0233 14.4584 34.9171C14.1769 34.809 13.878 34.7534 13.5765 34.7531C13.2477 34.7519 12.922 34.8174 12.6192 34.9456L7.24353 36.8854C7.12605 36.9362 7.00154 36.9688 6.87426 36.9821C6.77359 36.9818 6.67397 36.9615 6.58118 36.9225C6.48839 36.8834 6.40426 36.8264 6.33366 36.7546C6.26307 36.6828 6.2074 36.5978 6.16989 36.5043C6.13238 36.4109 6.11377 36.311 6.11513 36.2103C6.12174 36.122 6.13768 36.0346 6.16268 35.9496L7.71739 30.3259Z"
                    stroke="#557EFB"
                    stroke-width="1.90179"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                  />
                  <path
                    d="M13.4644 23.0357C14.8649 23.0357 16.0001 21.9004 16.0001 20.4999C16.0001 19.0995 14.8649 17.9642 13.4644 17.9642C12.064 17.9642 10.9287 19.0995 10.9287 20.4999C10.9287 21.9004 12.064 23.0357 13.4644 23.0357Z"
                    fill="#557EFB"
                  />
                  <path
                    d="M21.0718 23.0357C22.4723 23.0357 23.6076 21.9004 23.6076 20.4999C23.6076 19.0995 22.4723 17.9642 21.0718 17.9642C19.6714 17.9642 18.5361 19.0995 18.5361 20.4999C18.5361 21.9004 19.6714 23.0357 21.0718 23.0357Z"
                    fill="#557EFB"
                  />
                  <path
                    d="M28.6783 23.0357C30.0787 23.0357 31.214 21.9004 31.214 20.4999C31.214 19.0995 30.0787 17.9642 28.6783 17.9642C27.2779 17.9642 26.1426 19.0995 26.1426 20.4999C26.1426 21.9004 27.2779 23.0357 28.6783 23.0357Z"
                    fill="#557EFB"
                  />
                </svg>
              </b-button>
              <b-popover
                :target="`popover-target-${row.item.id}`"
                triggers="hover"
                placement="top"
              >
                <template #title>Blog Feedback</template>
                <div>
                  <span class="mr-2">Thank Yous:</span>
                  <span
                    v-if="row.item.feedback && row.item.feedback.thankyous"
                    >{{ row.item.feedback.thankyous.length }}</span
                  >
                  <span v-else>0</span>
                </div>
                <div>
                  <span class="mr-2">Comments:</span>
                  <span
                    v-if="row.item.feedback && row.item.feedback.feedback"
                    >{{ row.item.feedback.feedback.length }}</span
                  >
                  <span v-else>0</span>
                </div>
                <div>
                  <span class="mr-2">Bookmarks:</span>
                  <span v-if="row.item.feedback && row.item.feedback.bookmarks">
                    {{ row.item.feedback.bookmarks.length }}
                  </span>
                  <span v-else>0</span>
                </div>
                <div>
                  <span class="mr-2">Views:</span>
                  <span v-if="row.item.feedback && row.item.feedback.views">
                    {{ row.item.feedback.views.length }}
                  </span>
                  <span v-else>0</span>
                </div>
              </b-popover>
            </template>
            <template #cell(editBlog)="row">
              <div class="actions">
                <b-link
                  size="sm"
                  @click="editBlog(row.item)"
                  class="mt-2"
                  :disabled="loadingwpArticles"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.66667 3.33333C2.48986 3.33333 2.32029 3.40357 2.19527 3.5286C2.07024 3.65362 2.00001 3.82319 2.00001 4V13.3333C2.00001 13.5101 2.07024 13.6797 2.19527 13.8047C2.32029 13.9298 2.48986 14 2.66667 14H12C12.1768 14 12.3464 13.9298 12.4714 13.8047C12.5964 13.6797 12.6667 13.5101 12.6667 13.3333V9.77333C12.6667 9.40514 12.9651 9.10667 13.3333 9.10667C13.7015 9.10667 14 9.40514 14 9.77333V13.3333C14 13.8638 13.7893 14.3725 13.4142 14.7475C13.0391 15.1226 12.5304 15.3333 12 15.3333H2.66667C2.13624 15.3333 1.62753 15.1226 1.25246 14.7475C0.877385 14.3725 0.666672 13.8638 0.666672 13.3333V4C0.666672 3.46957 0.877385 2.96086 1.25246 2.58579C1.62753 2.21071 2.13624 2 2.66667 2H6.22667C6.59486 2 6.89334 2.29848 6.89334 2.66667C6.89334 3.03486 6.59486 3.33333 6.22667 3.33333H2.66667Z"
                      fill="#B3C2CB"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.5286 0.862254C11.7889 0.601905 12.2111 0.601905 12.4714 0.862254L15.1381 3.52892C15.3984 3.78927 15.3984 4.21138 15.1381 4.47173L8.47141 11.1384C8.34639 11.2634 8.17682 11.3337 8 11.3337H5.33334C4.96515 11.3337 4.66667 11.0352 4.66667 10.667V8.00033C4.66667 7.82351 4.73691 7.65394 4.86193 7.52892L11.5286 0.862254ZM6.00001 8.27647V10.0003H7.72386L13.7239 4.00033L12 2.27647L6.00001 8.27647Z"
                      fill="#B3C2CB"
                    />
                  </svg>
                </b-link>
                <b-link
                  size="sm"
                  class="mt-2"
                  :disabled="loadingwpArticles"
                  @click="showDeleteBlog(row.item)"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1 3C1 2.72386 1.22386 2.5 1.5 2.5H10.5C10.7761 2.5 11 2.72386 11 3C11 3.27614 10.7761 3.5 10.5 3.5H1.5C1.22386 3.5 1 3.27614 1 3Z"
                      fill="#FF8C7D"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5 1.5C4.86739 1.5 4.74022 1.55268 4.64645 1.64645C4.55268 1.74021 4.5 1.86739 4.5 2V2.5H7.5V2C7.5 1.86739 7.44732 1.74021 7.35355 1.64645C7.25979 1.55268 7.13261 1.5 7 1.5H5ZM8.5 2.5V2C8.5 1.60217 8.34196 1.22064 8.06066 0.93934C7.77936 0.658035 7.39782 0.5 7 0.5H5C4.60218 0.5 4.22064 0.658035 3.93934 0.93934C3.65804 1.22064 3.5 1.60217 3.5 2V2.5H2.5C2.22386 2.5 2 2.72386 2 3V10C2 10.3978 2.15804 10.7794 2.43934 11.0607C2.72064 11.342 3.10217 11.5 3.5 11.5H8.5C8.89783 11.5 9.27936 11.342 9.56066 11.0607C9.84196 10.7794 10 10.3978 10 10V3C10 2.72386 9.77614 2.5 9.5 2.5H8.5ZM3 3.5V10C3 10.1326 3.05268 10.2598 3.14645 10.3536C3.24021 10.4473 3.36739 10.5 3.5 10.5H8.5C8.63261 10.5 8.75978 10.4473 8.85355 10.3536C8.94732 10.2598 9 10.1326 9 10V3.5H3Z"
                      fill="#FF8C7D"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5 5C5.27614 5 5.5 5.22386 5.5 5.5V8.5C5.5 8.77614 5.27614 9 5 9C4.72386 9 4.5 8.77614 4.5 8.5V5.5C4.5 5.22386 4.72386 5 5 5Z"
                      fill="#FF8C7D"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7 5C7.27614 5 7.5 5.22386 7.5 5.5V8.5C7.5 8.77614 7.27614 9 7 9C6.72386 9 6.5 8.77614 6.5 8.5V5.5C6.5 5.22386 6.72386 5 7 5Z"
                      fill="#FF8C7D"
                    />
                  </svg>
                </b-link>
              </div>
            </template>
            <template #cell(editStatus)="row">
              <div class="status">
                <span
                  class="status-btn"
                  :style="{ background: getStatusColor(row.item.status) }"
                >
                  {{ getStatus(row.item.status) }}
                </span>
                <b-link
                  style="{ display: block }"
                  size="sm"
                  @click="editStatus(row.item)"
                  class="mt-2"
                >
                  <small>Update</small>
                </b-link>
              </div>
            </template>
            <template #cell(details)="row">
              <b-icon
                v-if="row.detailsShowing"
                @click="row.toggleDetails"
                icon="chevron-compact-up"
                font-scale="2"
              >
              </b-icon>
              <b-icon
                v-else
                @click="row.toggleDetails"
                icon="chevron-compact-down"
                font-scale="2"
              >
              </b-icon>
            </template>
            <template #row-details="row">
              <b-card>
                <div class="entry">
                  <span class="heading">Blog ID:</span>
                  <span>{{ row.item.id }} </span>
                </div>
                <div
                  class="entry"
                  v-if="row.item.blog && row.item.blog.summary"
                >
                  <span class="heading">Summary</span>
                  <span>{{ row.item.blog.summary.substring(0, 300) }} </span>
                </div>
                <div class="entry">
                  <span class="heading">Synopsis:</span>
                  <span v-if="row.item.doc && row.item.doc.synopsis"
                    >{{ row.item.doc.synopsis.substring(0, 90) }}
                  </span>
                  <span v-else>-</span>
                </div>
                <div class="entry">
                  <span class="heading">Slug:</span>
                  <span v-if="row.item.slug">{{ row.item.slug }} </span>
                  <span v-else>-</span>
                </div>
                <div class="entry">
                  <span class="heading">SEOs:</span>
                  <span v-if="row.item.doc.seo.length > 0">
                    <span v-for="(tag, i) in row.item.doc.seo" :key="i">
                      {{ tag }}
                    </span>
                  </span>
                  <span v-else>-</span>
                </div>
                <div class="entry d-flex align-center">
                  <span class="heading">Guides:</span>
                  <div
                    class="detail-tools"
                    v-if="
                      row.item.doc &&
                        row.item.doc.guides &&
                        row.item.doc.guides.length > 0
                    "
                  >
                    <img
                      v-for="(guide, i) in row.item.doc.guides"
                      :src="guide.imgURL"
                      :key="i"
                      :alt="guide.name"
                      v-b-tooltip.hover
                      :title="guide.name"
                      width="85"
                      height="75"
                      class="mr-2"
                    />
                  </div>
                  <span v-else>-</span>
                </div>
                <div class="entry d-flex align-center">
                  <span class="heading">Tools:</span>
                  <div
                    class="detail-tools"
                    v-if="
                      row.item.doc &&
                        row.item.doc.tools &&
                        row.item.doc.tools.length > 0
                    "
                  >
                    <img
                      v-for="(tool, i) in row.item.doc.tools"
                      :src="tool.imgURL"
                      :key="i"
                      :alt="tool.name"
                      v-b-tooltip.hover
                      :title="tool.name"
                      width="85"
                      height="75"
                    />
                  </div>
                  <span v-else>-</span>
                </div>
                <div class="entry d-flex align-center">
                  <span class="heading">Connections:</span>
                  <div
                    class="detail-tools"
                    v-if="
                      row.item.doc &&
                        row.item.doc.connections &&
                        row.item.doc.connections.length > 0
                    "
                  >
                    <img
                      v-for="(connection, i) in row.item.doc.connections"
                      :src="connection.imgURL"
                      :key="i"
                      :alt="connection.name"
                      v-b-tooltip.hover
                      :title="connection.name"
                      width="85"
                      height="75"
                    />
                  </div>
                  <span v-else>-</span>
                </div>
              </b-card>
            </template>
          </b-table>
        </b-card>
        <b-pagination
          v-model="currentPage"
          :total-rows="allBlogs.length"
          :per-page="perPage"
          align="left"
          size="sm"
          class="my-0"
        ></b-pagination>
      </div>
      <modal :id="blogModal">
        <div v-if="edit" class="add-user">
          <span class="close-icon" @click="closeEditModal">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>Edit Blog</h3>
          <div class="h-18"></div>
          <b-form-group
              label="Blog Title"
              label-for="title"
          >
            <b-form-input
              id="title"
              type="text"
              required
              v-model="modalTitle"
              placeholder="Title"
           />
          </b-form-group>

          <b-form-group
              label-for="wp-post"
          >
            <label-info
                id="wp-post"
                label-name="WordPress Post"
                label-info="Select the post to associate with this blog"
            />
          <b-dropdown
              id="dropdown-wp-post"
              class="m-md-2"
          >
            <template #button-content>
              Custom <strong>Content</strong> with <em>HTML</em> via Slot
            </template>
            <b-dropdown-item v-for="(wpPost, i) in wpArticles"
                             :key="`wpo_${i}`"
            >
              {{ wpPost }}
            </b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item active>Active action</b-dropdown-item>
            <b-dropdown-item disabled>Disabled action</b-dropdown-item>
          </b-dropdown>
          </b-form-group>


          <b-form-group
              label="WordPress Posts"
              label-for="dropdown"
          >
            <b-dropdown
              variant="primary"
              ref="wpDropdown"
              id="dropdown"
              block
              :text="getWordPressText()"
              menu-class="w-80"
            >
              <div
                  v-for="(post, i) in wpArticles" :key="i">
                <div
                  @click="handleAssociatePost(post)"
                  class="post"
                  :class="selectedWpId == post.id ? 'active' : ''"
                >
                  <div>
                    <span>
                      WordPress ID:
                    </span>
                    {{ post.id }}
                  </div>
                  <div>
                    <span>
                      Title:
                    </span>
                    {{ post.title.rendered }}
                  </div>
                  <div>
                    <span>
                      Slug:
                    </span>
                    {{ post.slug }}
                  </div>
                  <div>
                    <span>
                      Link:
                    </span>
                    <a target="_blank" :href="post.link">{{ post.link }}</a>
                  </div>
                </div>
              </div>
            </b-dropdown>
          </b-form-group>
          <b-form-group label="Bloggers" label-for="bloggersDropdown">
            <b-dropdown
              variant="primary"
              ref="bloggersDropdown"
              id="bloggersDropdown"
              block
              :text="getBloggerText()"
              menu-class="w-80"
            >
              <div v-for="(blogger, i) in allBloggers" :key="i">
                <div
                  @click="associateBlogger(blogger)"
                  class="post"
                  :class="
                    currentBlogger &&
                    currentBlogger.bloggerId == blogger.bloggerId
                      ? 'active'
                      : ''
                  "
                >
                  <img
                    v-if="blogger.user && blogger.user.imgURL"
                    :src="blogger.user.imgURL"
                    class="blogger-image"
                    alt="Blogger Image"
                  />
                  <b-avatar v-else></b-avatar>
                  <span
                    class="mr-2"
                    v-if="blogger.user && blogger.user.firstname"
                  >
                    {{ blogger.user.firstname + " " + blogger.user.lastname }}
                  </span>
                  <span v-else>{{ blogger.bloggerId }}</span>
                </div>
              </div>
            </b-dropdown>
          </b-form-group>
          <b-form-group label="Blog Slug" label-for="slug">
            <b-form-input
              id="slug"
              type="text"
              required
              v-model="modalSlug"
              placeholder="Slug"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Blog Read (minutes)" label-for="read">
            <b-form-input
              id="read"
              type="text"
              required
              v-model="modalMins"
              placeholder="Minutes Read"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            class="textarea-scroll"
            label="Blog Summary"
            label-for="summary"
          >
            <b-form-textarea
              id="summary"
              rows="4"
              no-resize
              v-model="modalSummary"
              placeholder="Your Summary"
              :disabled="true"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group label="Images">
            <div class="blog-images" v-if="stripedImages.length > 0">
              <div v-for="(imgURL, index) in stripedImages" :key="index">
                <img
                  @click="selectImage(imgURL)"
                  :src="imgURL"
                  alt="Blog Image"
                  class="blog-image"
                  :class="activeImg == imgURL ? 'active-image' : ''"
                />
              </div>
            </div>
            <span v-else>No Images in this blog.</span>
          </b-form-group>
          <div class="d-flex justify-content-between">
            <b-button variant="light btn-simple" @click="closeEditModal">
              Cancel
            </b-button>
            <b-button variant="primary btn-round-fill" @click="updateBlog">
              Update
            </b-button>
          </div>
        </div>
        <div class="add-user del-user" v-else>
          <span class="close-icon" @click="$bvModal.hide(blogModal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>Delete Article</h3>
          <div class="warning-msg">
            <p>
              Are you sure want to delete this Article?
            </p>
          </div>
          <div class="d-flex justify-content-between">
            <b-button variant="danger btn-round-fill" @click="deleteBlog">
              Yes! Delete
            </b-button>
            <b-button variant="light btn-simple" @click="hideDeleteBlog">
              No! back
            </b-button>
          </div>
        </div>
      </modal>
      <modal :id="blogStatusModal">
        <div class="add-user">
          <span class="close-icon" @click="closeStatusModal">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>Edit Status</h3>
          <div class="h-18"></div>
          <div class="article">
            <div class="img-article">
              <div class="cursor-pointer">
                <img
                  v-if="
                    selectedBlog &&
                      selectedBlog.blog &&
                      selectedBlog.blog.imgURL
                  "
                  :src="selectedBlog.blog.imgURL"
                  alt="Blog Image"
                />
              </div>
            </div>
            <div class="article-content">
              <div
                v-if="
                  selectedBlog && selectedBlog.blog && selectedBlog.blog.imgURL
                "
                class="cursor-pointer"
              >
                <h2 class="title">
                  {{ selectedBlog.blog.title }}
                </h2>
                <p class="description">
                  {{ selectedBlog.blog.summary.substring(0, 65) }}...
                </p>
              </div>
              <div class="details">
                <div class="cursor-pointer">
                  <div class="categories">
                    <span
                      class="ico ico-spiritual"
                      v-if="
                        selectedBlog &&
                          selectedBlog.doc &&
                          selectedBlog.doc.spheres &&
                          selectedBlog.doc.spheres.includes('s')
                      "
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0)">
                          <path
                            d="M9.26658 -0.104764C9.1645 -0.106395 9.06617 -0.0665622 8.99449 0.00617632L7.07606 1.91385C7.0062 1.9837 6.94215 2.05878 6.87764 2.13354C6.16411 1.54075 5.2691 1.20768 4.339 1.20843H3.4835C3.27485 1.20843 3.103 1.38036 3.103 1.58902V3.0478H1.64422C1.43557 3.0478 1.26404 3.21932 1.26404 3.42797V4.28345C1.26412 4.57004 1.30345 4.85459 1.36449 5.13446C1.10749 5.29573 0.863983 5.47839 0.649553 5.69328L0.0617934 6.28103C-0.085702 6.42857 -0.085702 6.67111 0.0617934 6.81865L1.9942 8.75139C2.06237 8.81958 2.13555 8.8817 2.20818 8.94434C1.6035 9.66125 1.2633 10.5652 1.26404 11.5056V12.3611C1.26406 12.5697 1.43557 12.7413 1.64422 12.7413H3.103V14.2C3.103 14.4087 3.27495 14.5806 3.4836 14.5806H4.339C4.63747 14.5805 4.93343 14.5383 5.22433 14.4721C5.38352 14.7243 5.56325 14.9634 5.7743 15.1744L6.364 15.7794C6.43482 15.852 6.53174 15.8933 6.63321 15.8941H6.63568C6.73614 15.8941 6.83275 15.8543 6.904 15.7835L8.82345 13.8752V13.8748C8.89312 13.8049 8.95718 13.73 9.02152 13.6552C9.73518 14.2483 10.6301 14.5813 11.5605 14.5805H12.4159C12.6246 14.5805 12.7964 14.4087 12.7964 14.2V12.7412H14.2553C14.4639 12.7412 14.6354 12.5697 14.6354 12.3611V11.5052C14.6354 11.2187 14.596 10.9344 14.535 10.6546C14.792 10.4933 15.0352 10.3108 15.2496 10.096L15.8377 9.50792C15.9852 9.36038 15.9852 9.11758 15.8377 8.97004L13.9052 7.03731C13.8371 6.96921 13.7639 6.90722 13.6913 6.84461C14.296 6.12771 14.6362 5.22382 14.6354 4.28342V3.42794C14.6354 3.21929 14.4639 3.04777 14.2553 3.04777H12.7964V1.58891C12.7964 1.38025 12.6246 1.2084 12.4159 1.2084H11.5605C11.262 1.20843 10.9657 1.25065 10.6748 1.31681C10.5159 1.06502 10.3368 0.826276 10.1261 0.615598L10.1243 0.614521L9.53458 0.00961071C9.46388 -0.0629536 9.36697 -0.10391 9.26567 -0.104858L9.26658 -0.104764ZM9.25895 0.81589L9.58319 1.14837L9.58596 1.15123C10.8465 2.41468 10.8464 4.4565 9.58596 5.72003L9.21716 6.08876C8.95124 5.9016 8.64992 5.77638 8.32962 5.72028V5.1999C8.32962 4.27568 8.00245 3.38568 7.41629 2.67394C7.47939 2.59807 7.54303 2.5226 7.61277 2.45273V2.45246L9.25895 0.81589ZM3.86337 1.96919H4.33834C6.12319 1.9711 7.56703 3.41504 7.56902 5.19989V5.72255C6.7502 5.86811 6.09213 6.45517 5.84606 7.2471C4.65524 6.74082 3.86667 5.58496 3.86337 4.28345V4.28308V1.96919ZM11.5605 1.96919H12.0358V3.0478H11.5605C11.4627 3.04787 11.3649 3.05554 11.2674 3.0627C11.2346 2.70691 11.1524 2.35892 11.0262 2.0248C11.2031 1.99513 11.3809 1.96925 11.5605 1.96921V1.96919ZM2.02441 3.80815H3.1027V4.28345C3.1027 4.37297 3.10971 4.46064 3.11577 4.54856C2.75886 4.57928 2.40952 4.65986 2.07401 4.78507C2.04791 4.61885 2.02452 4.45183 2.02444 4.28345L2.02441 3.80815ZM11.5605 3.80815H13.8748V4.28345C13.8729 6.06819 12.4291 7.51197 10.6444 7.51415H10.1237C10.0675 7.19376 9.94281 6.89224 9.75554 6.6263L10.1237 6.25815V6.25778C10.7793 5.60577 11.1775 4.74412 11.2658 3.82594C11.3637 3.81688 11.4618 3.80831 11.5602 3.80811L11.5605 3.80815ZM3.24576 5.30007C3.49135 6.21989 4.05912 7.00927 4.8371 7.5504C4.07378 7.63088 3.35003 7.92328 2.7517 8.40873C2.67626 8.34601 2.6013 8.28277 2.53175 8.21351L0.86826 6.54967L1.18737 6.23048C1.73653 5.6772 2.46952 5.35116 3.24543 5.30007H3.24576ZM7.9551 6.43192C8.00691 6.43251 8.05851 6.43612 8.10979 6.44227C8.24651 6.45868 8.38051 6.49411 8.50778 6.54682C9.01683 6.75766 9.40841 7.23954 9.40841 7.89441C9.40657 8.70106 8.75624 9.3521 7.94964 9.3532C7.29476 9.3532 6.81252 8.96196 6.6017 8.45289C6.39087 7.94383 6.45503 7.32616 6.91804 6.86315C7.22188 6.55931 7.59244 6.42722 7.9551 6.43193V6.43192ZM13.1474 7.38033H13.1475C13.2229 7.44305 13.2979 7.50629 13.3674 7.57555L15.0313 9.23905L14.7118 9.5585C14.1626 10.1117 13.4296 10.4378 12.6537 10.489C12.4082 9.56923 11.8403 8.7798 11.0624 8.23866C11.8257 8.1582 12.5494 7.86579 13.1477 7.38033H13.1474ZM5.25479 8.27491H5.25487H5.77524C5.83136 8.59522 5.95646 8.89654 6.14365 9.16243L5.7755 9.53091C5.11975 10.1829 4.72139 11.0444 4.63305 11.9628C4.53502 11.9718 4.4368 11.9804 4.33834 11.9806H2.02441V11.5056C2.02626 9.7209 3.47013 8.27714 5.25479 8.27491V8.27491ZM10.0531 8.54188C11.244 9.04822 12.0326 10.204 12.0358 11.5056V13.8199H11.5605C9.77566 13.8178 8.33181 12.374 8.3298 10.5892V10.0665C9.14876 9.92105 9.80703 9.33391 10.0531 8.54188ZM6.68153 9.70031C6.9475 9.88754 7.24896 10.0126 7.56937 10.0687V10.5892C7.56937 11.5132 7.89637 12.4031 8.48237 13.1148C8.41936 13.1907 8.35585 13.2664 8.28624 13.3363L6.64023 14.9732L6.31439 14.6388C6.31439 14.6391 6.31439 14.6382 6.31439 14.6384V14.638V14.6376C5.05178 13.375 5.05178 11.3316 6.31439 10.0689L6.68153 9.70031ZM13.8251 11.0037C13.8512 11.17 13.8747 11.3371 13.8748 11.5056V11.9806H12.7965V11.5056C12.7965 11.416 12.7895 11.3282 12.7834 11.2402C13.1404 11.2095 13.4895 11.1289 13.8251 11.0037H13.8251ZM4.63181 12.7263C4.66451 13.0821 4.74642 13.4301 4.87267 13.7642C4.69579 13.7938 4.51816 13.8198 4.33866 13.8199H3.86345V12.7413H4.33866C4.43651 12.7412 4.53422 12.7335 4.63181 12.7263V12.7263Z"
                            fill="#A1B1BA"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    <span
                      class="ico ico-health"
                      v-if="
                        selectedBlog &&
                          selectedBlog.doc &&
                          selectedBlog.doc.spheres &&
                          selectedBlog.doc.spheres.includes('h')
                      "
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.42445 1.23083C3.20077 1.23083 2.07729 1.7187 1.25741 2.60519C0.447254 3.48128 0 4.67919 0 5.97995C0 7.31808 0.498278 8.54108 1.57727 9.83907C2.54263 11.0003 3.93499 12.184 5.54929 13.5554C5.55019 13.5561 5.5511 13.5568 5.55195 13.5576C6.10256 14.0253 6.7265 14.556 7.37413 15.1205C7.53604 15.2619 7.7439 15.3394 7.95955 15.3394C8.17504 15.3394 8.38311 15.2617 8.54492 15.1205C9.194 14.5546 9.81881 14.0235 10.3704 13.555C11.9845 12.1837 13.3767 11 14.3421 9.8387C15.4211 8.54082 15.9197 7.31807 15.9197 5.97995C15.9197 4.67919 15.4724 3.48128 14.6623 2.60519C13.8424 1.7187 12.7189 1.23083 11.4953 1.23083C10.5813 1.23083 9.74634 1.51833 9.00906 2.08679C8.63688 2.37373 8.29931 2.72511 8.00136 3.13568C7.99655 3.14225 7.99028 3.14758 7.983 3.15126C7.97573 3.15495 7.96766 3.15687 7.9595 3.15687C7.95134 3.15687 7.94332 3.15495 7.93604 3.15126C7.92877 3.14758 7.92245 3.14225 7.91764 3.13568C7.6198 2.72511 7.28237 2.37372 6.91031 2.08679C6.17303 1.51833 5.33815 1.23083 4.42413 1.23083H4.42445ZM4.42445 2.06336C5.14757 2.06336 5.8138 2.29359 6.39944 2.74505C6.92162 3.14765 7.28306 3.65423 7.49527 4.00884C7.59426 4.17419 7.76696 4.27207 7.95982 4.27207C8.15268 4.27207 8.32538 4.17419 8.42437 4.00884C8.63667 3.65425 8.99815 3.14765 9.5202 2.74505C10.1058 2.2936 10.772 2.06336 11.4952 2.06336C12.4811 2.06336 13.3893 2.45648 14.0486 3.16936C14.7177 3.89293 15.0849 4.89149 15.0849 5.97995C15.0849 7.12899 14.6542 8.15963 13.6997 9.30785C12.777 10.4178 11.4102 11.5781 9.82942 12.9213C9.27566 13.3916 8.64822 13.9248 7.99251 14.4941C7.98305 14.5023 7.97092 14.5069 7.95835 14.5069C7.94579 14.5069 7.93365 14.5023 7.9242 14.4941C7.27333 13.9267 6.64822 13.3951 6.0961 12.9261L6.09312 12.9239C6.09222 12.9232 6.09131 12.9224 6.09046 12.9217C4.50953 11.5785 3.14249 10.4178 2.2198 9.30786C1.26524 8.15965 0.834588 7.129 0.834588 5.97996C0.834588 4.8915 1.20183 3.89294 1.87095 3.16937C2.53031 2.4565 3.43825 2.06337 4.42431 2.06337L4.42445 2.06336Z"
                          fill="#A1B1BA"
                        />
                      </svg>
                    </span>
                    <span
                      class="ico ico-education"
                      v-if="
                        selectedBlog &&
                          selectedBlog.doc &&
                          selectedBlog.doc.spheres &&
                          selectedBlog.doc.spheres.includes('e')
                      "
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.83299 14.25C1.55684 14.25 1.33301 14.0261 1.33301 13.75V2.0625C1.33301 0.92522 2.25825 0 3.39554 0H13.6604C13.9366 0 14.1604 0.223875 14.1604 0.499999V12C14.1604 12.2761 13.9366 12.5 13.6604 12.5C13.3843 12.5 13.1604 12.2761 13.1604 12V0.999998H3.39554C2.80966 0.999998 2.33303 1.47663 2.33303 2.0625V13.75C2.33303 14.0261 2.10915 14.25 1.83299 14.25V14.25Z"
                          fill="#A1B1BA"
                        />
                        <path
                          d="M13.6604 16H3.58302C2.34236 16 1.33301 14.9907 1.33301 13.75C1.33301 12.5093 2.34236 11.5 3.58302 11.5H13.6604C13.9366 11.5 14.1604 11.7239 14.1604 12C14.1604 12.2761 13.9366 12.5 13.6604 12.5H3.58302C2.89377 12.5 2.33303 13.0608 2.33303 13.75C2.33303 14.4393 2.89377 15 3.58302 15H13.6604C13.9366 15 14.1604 15.2239 14.1604 15.5C14.1604 15.7761 13.9366 16 13.6604 16V16Z"
                          fill="#A1B1BA"
                        />
                        <path
                          d="M13.6604 14.25H3.58299C3.30684 14.25 3.08301 14.0261 3.08301 13.75C3.08301 13.4739 3.30684 13.25 3.58299 13.25H13.6604C13.9365 13.25 14.1603 13.4739 14.1603 13.75C14.1603 14.0261 13.9365 14.25 13.6604 14.25Z"
                          fill="#A1B1BA"
                        />
                        <path
                          d="M4.08299 12.5C3.80686 12.5 3.58301 12.2761 3.58301 12V0.499999C3.58301 0.223875 3.80686 0 4.08299 0C4.35915 0 4.58298 0.223875 4.58298 0.499999V12C4.58298 12.2761 4.35915 12.5 4.08299 12.5Z"
                          fill="#A1B1BA"
                        />
                      </svg>
                    </span>
                    <span
                      class="ico ico-finance"
                      v-if="
                        selectedBlog &&
                          selectedBlog.doc &&
                          selectedBlog.doc.spheres &&
                          selectedBlog.doc.spheres.includes('f')
                      "
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.57129 0.592529C2.64516 0.596591 1.89356 1.34214 1.87837 2.26855H1.69992C0.764337 2.26855 0.00410311 3.02468 0 3.96029C0 3.96037 0 3.96041 0 3.96049V13.1108C0 13.1109 0 13.1109 0 13.111C0.00409393 14.0465 0.760108 14.8106 1.69973 14.8147H12.142C13.0681 14.8107 13.8197 14.0651 13.8349 13.1387H14.0134C14.9489 13.1387 15.7092 12.3826 15.7133 11.447C15.7133 11.4469 15.7133 11.4469 15.7133 11.4468V2.29636C15.7133 2.29629 15.7133 2.29623 15.7133 2.29617C15.7092 1.35682 14.953 0.596632 14.0135 0.59253H3.57129V0.592529ZM3.57129 1.48624H3.57176H14.0136C14.4586 1.49021 14.8161 1.8514 14.8199 2.29672V4.22342L13.838 5.48884V3.96047C13.838 3.02475 13.0777 2.26855 12.1421 2.26855H2.772C2.78684 1.83663 3.13591 1.49012 3.57139 1.48624H3.57129ZM1.69973 3.16226H12.142C12.5833 3.16226 12.9442 3.51552 12.9442 3.96047V6.20065C12.8886 6.21071 12.8327 6.21918 12.7805 6.21918H10.4779C9.19893 6.21918 8.15946 7.25865 8.15946 8.53759C8.15946 9.81652 9.19883 10.856 10.4777 10.8601H12.7763C12.7772 10.8601 12.778 10.8601 12.7789 10.8601C12.8342 10.857 12.8874 10.8507 12.9401 10.8448L12.944 13.1109C12.944 13.5559 12.5868 13.917 12.1418 13.921H1.69993H1.69946C1.25459 13.917 0.897216 13.5559 0.893252 13.1108V3.96092V3.96046C0.897253 3.51944 1.2544 3.16225 1.69946 3.16225L1.69973 3.16226ZM14.8159 5.6841L14.8197 7.96671L13.5806 9.57395C13.3902 9.82142 13.0927 9.96656 12.7799 9.97037H10.4781H10.4777C9.68939 9.96636 9.05298 9.32978 9.05298 8.54159C9.05298 7.75339 9.68938 7.1169 10.4777 7.11289H12.7763C13.0584 7.11289 13.3367 7.05163 13.5907 6.9288L13.5912 6.92861C13.8615 6.80157 14.0986 6.60933 14.2826 6.37217V6.37209L14.8159 5.6841ZM10.4141 8.09473C10.1685 8.09473 9.96723 8.29602 9.96723 8.54159C9.96723 8.78716 10.1685 8.98844 10.4141 8.98844H11.3718C11.6173 8.98844 11.8186 8.78716 11.8186 8.54159C11.8186 8.29602 11.6173 8.09473 11.3718 8.09473H10.4141ZM14.8197 9.42748V11.4468C14.8157 11.8878 14.4586 12.245 14.0135 12.245H13.8379V10.528C14.0048 10.4122 14.157 10.2725 14.2858 10.1164C14.2862 10.116 14.2865 10.1156 14.2868 10.1152L14.8197 9.42748Z"
                          fill="#A1B1BA"
                        />
                      </svg>
                    </span>
                    <span
                      class="read"
                      v-if="
                        selectedBlog &&
                          selectedBlog.blog &&
                          selectedBlog.blog.mins
                      "
                    >
                      {{ selectedBlog.blog.mins }} Min Read ∙
                      {{ formatDate(new Date()) }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="article-foot">
                <div class="author">
                  <img
                    v-if="
                      selectedBlog &&
                        selectedBlog.blogger &&
                        selectedBlog.blogger.imgURL
                    "
                    :src="selectedBlog.blogger.imgURL"
                    :alt="selectedBlog.blogger.firstname"
                  />
                  <!-- <h5>{{ bloggerFullname }}</h5> -->
                  <h5 v-if="selectedBlog && selectedBlog.blogger">
                    {{
                      selectedBlog.blogger.firstname +
                        " " +
                        selectedBlog.blogger.lastname
                    }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tools"
            v-if="
              selectedBlog &&
                selectedBlog.doc &&
                selectedBlog.doc.guides &&
                selectedBlog.doc.guides.length > 0
            "
          >
            <h6>Guides:</h6>
            <img
              v-for="(guide, i) in selectedBlog.doc.guides"
              :src="guide.imgURL"
              :key="i"
              :alt="guide.name"
              v-b-tooltip.hover
              :title="guide.name"
              width="30"
            />
          </div>
          <div
            class="tools"
            v-if="
              selectedBlog &&
                selectedBlog.doc &&
                selectedBlog.doc.tools &&
                selectedBlog.doc.tools.length > 0
            "
          >
            <h6>Tools:</h6>
            <img
              v-for="(tool, i) in selectedBlog.doc.tools"
              :src="tool.imgURL"
              :key="i"
              :alt="tool.name"
              v-b-tooltip.hover
              :title="tool.name"
              width="30"
            />
          </div>
          <div
            class="tools"
            v-if="
              selectedBlog &&
                selectedBlog.doc &&
                selectedBlog.doc.connections &&
                selectedBlog.doc.connections.length > 0
            "
          >
            <h6>Connections:</h6>
            <img
              v-for="(connection, i) in selectedBlog.doc.connections"
              :src="connection.imgURL"
              :key="i"
              :alt="connection.name"
              v-b-tooltip.hover
              :title="connection.name"
              width="30"
            />
          </div>
          <b-form-group class="mt-3">
            <b-form-select
              v-model="modalStatus"
              :options="statusOptions"
            ></b-form-select>
          </b-form-group>
          <div class="d-flex justify-content-between mt-4">
            <b-button variant="light btn-simple" @click="closeStatusModal">
              Cancel
            </b-button>
            <b-button variant="primary btn-round-fill" @click="updateStatus">
              Update
            </b-button>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import LabelInfo from '@/components/common/labelInfo';
import Modal from "@/components/common/modal";
import WPAPI from "wpapi";

export default {
  name:"Admin_Manage_Articles",
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Modal,
    LabelInfo
  },
  computed: {
    ...mapGetters({
      allBlogs: "admin/blogs",
      allBloggers: "admin/activeBloggers"
    }),
    blogs() {
      if (this.searchStr.trim() == "") return this.allBlogs;
      let filteredBlogs = [];

      filteredBlogs = this.allBlogs.filter(blog => {
        return (
          blog.doc.title
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim()) ||
          blog.blog.title
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim())
        );
      });

      return filteredBlogs;
    }
  },
  mounted() {},
  methods: {
    getBlogs() {
      this.$store.dispatch("admin/getBlogs").then((resp)=>{
      });
    },
    handleActivation() {
      //lazy load only on selection. Prevent unecessary pulls and other benefits
      this.getBlogs();
      this.getWPArticlePosts();
      this.handleGetWpArticles();
    },
    async getWPArticlePosts() {
      this.loadingwpArticles = true;
      const BASEURL = this.wordPress.baseURL;
      const PATHURLPOSTS = this.wordPress.pathURLPosts;
      const USERNAME = this.wordPress.username;
      const PASSWORD = this.wordPress.password;

      const res = await axios
          .get(`${BASEURL}/${PATHURLPOSTS}`, {
            auth: {
              username: USERNAME,
              password: PASSWORD
            }
          })
          .catch(err => err);

      debugger;
      if (res.status === 200) {
        this.loadingwpArticles = false;
        this.wpArticles = res.data;
        this.wpPosts = _.clone(res.data);


      } else {
        this.loadingwpArticles = false;
        console.log(res.message);
        console.log(res.response.status);
      }
    },
    async getArticleWPPost(postId) {
      const BASEURL = this.wordPress.baseURL;
      const PATHURLPOSTS = this.wordPress.pathURLPosts;
      const USERNAME = this.wordPress.username;
      const PASSWORD = this.wordPress.password;

      const res = await axios
          .get(`${BASEURL}/${PATHURLPOSTS}/${postId}`, {
            auth: {
              username: USERNAME,
              password: PASSWORD
            }
          })
          .catch(err => err);

      const vm = this;
      if (res.status === 200) {
        vm.wpData = res.data;
      } else {
        console.log(res.message);
        console.log(res.response.status);
      }
    },
    handleGetWpArticles(){
      const site = this.wordPress.baseURL;
      const apiPromise = WPAPI.discover( site );

      apiPromise.then(function( site ) {
        // If default routes were detected, they are now available
        site.posts().then(function( posts ) {
          console.log( posts );
        }); // etc

        // If custom routes were detected, they can be accessed via .namespace()
        site.namespace( 'myplugin/v1' ).authors()
            .then(function( authors ) { /* ... */ });

        // Namespaces can be saved out to variables:
        var myplugin = site.namespace( 'myplugin/v1' );
        myplugin.authors()
            .id( 7 )
            .then(function( author ) { /* ... */ });
      }).catch((e)=>{
        console.log(e);
      });
    },
    formatDate(date) {
      return moment(date).format("DD MMMM");
    },
    copytoClipboard(link) {
      navigator.clipboard.writeText(link);
      this.popupText = "Copied!";
    },
    changePopupText() {
      setTimeout(() => {
        this.popupText = "Copy to clipboard";
      }, 300);
    },
    editBlog(blog) {
      this.edit = true;
      this.resetForm();
      this.selectedBlogId = blog.id;
      if (blog.blogger) this.currentBlogger = blog.blogger;
      if (blog.blog && blog.blog.title) {
        this.modalTitle = blog.blog.title;
      } else {
        this.modalTitle = blog.doc.title;
      }
      if (blog.blog && blog.blog.mins) {
        this.modalMins = blog.blog.mins;
      }
      if (blog.blog && blog.blog.summary) {
        this.modalSummary = blog.blog.summary;
      }
      if (blog.blog && blog.blog.imgURL) {
        this.activeImg = blog.blog.imgURL;
      }
      if (blog.blog && blog.blog.wpId) {
        this.selectedWpId = blog.blog.wpId;
        this.stripedImages = this.getImages(blog.blog.wpId);
      }
      if (blog.slug) {
        this.modalSlug = blog.slug;
      }
      this.$bvModal.show(this.blogModal);
    },
    getSummary(id) {
      let summary = "";
      let article = this.wpArticles.filter(article => article.id === id);
      var el = document.createElement("div");
      el.innerHTML = article[0].content.rendered;
      var texts = [].map.call(el.querySelectorAll("p"), function(p) {
        return p.textContent;
      });
      for (let index = 0; index < texts.length; index++) {
        if (texts[index] !== "") {
          summary += texts[index];
        }
      }
      return summary;
    },
    calculateMinutes(summary) {
      let wordsCount = summary.match(/(\w+)/g).length;
      let mins = Math.ceil(wordsCount / 200);
      return mins;
    },
    getImages(id) {
      let imageUrls = [];
      let article = this.wpArticles.filter(article => article.id === id);
      let content = article[0].content.rendered;
      var elem = document.createElement("div");
      elem.innerHTML = content;
      var images = elem.getElementsByTagName("img");
      for (var i = 0; i < images.length; i++) {
        imageUrls.push(images[i].src);
      }
      return imageUrls;
    },
    getStatus(status) {
      if (status == "draft") {
        return "Draft";
      } else if (status == "submitted") {
        return "Submitted";
      } else if (status == "need_work") {
        return "Needs Work";
      } else if (status == "inactive") {
        return "Removed";
      } else if (status == "active") {
        return "Published";
      }
    },
    getStatusColor(status) {
      if (status == "draft") {
        return "#C0C0C0";
      } else if (status == "submitted") {
        return "#557efb";
      } else if (status == "need_work") {
        return "#FFCC00";
      } else if (status == "inactive") {
        return "#FF0000";
      } else if (status == "active") {
        return "#4BB543";
      }
    },
    handleAssociatePost(post) {
      let summary = this.getSummary(post.id);
      this.selectedWpId = post.id;
      this.activeImg = null;
      this.modalSlug = post.slug;
      this.modalMins = this.calculateMinutes(summary);
      this.modalSummary = summary.substring(0, 125) + "...";
      this.stripedImages = this.getImages(post.id);
    },
    associateBlogger(blogger) {
      this.currentBlogger = blogger;
      this.currentBlogger = {
        bloggerId: blogger.bloggerId,
        firstname: blogger.user.firstname,
        lastname: blogger.user.lastname,
        imgURL: blogger.user.imgURL,
        profileName: blogger.profile.profileName
      };
      this.$refs.bloggersDropdown.hide(true);
    },
    getWordPressText() {
      let text = "WordPress Posts";
      this.wpArticles.forEach(element => {
        if (element.id == this.selectedWpId) {
          text = element.title.rendered;
        }
      });
      return text;
    },
    getBloggerText() {
      let text = "Bloggers";
      this.allBloggers.forEach(element => {
        if (this.currentBlogger) {
          if (element.bloggerId == this.currentBlogger.bloggerId) {
            if (element.user.firstname) {
              text = element.user.firstname + " " + element.user.lastname;
            } else {
              text = element.bloggerId;
            }
          }
        }
      });
      return text;
    },
    selectImage(url) {
      this.activeImg = url;
    },
    updateBlog() {
      let updates = {
        id: this.selectedBlogId,
        wpId: this.selectedWpId,
        title: this.modalTitle,
        slug: this.modalSlug,
        mins: this.modalMins,
        summary: this.modalSummary,
        imgURL: this.activeImg,
        blogger: this.currentBlogger
      };
      this.$store.dispatch("admin/updateBlog", updates).then(() => {
        this.getBlogs();
        this.resetForm();
        this.$bvModal.hide(this.blogModal);
      });
    },
    closeEditModal() {
      this.$bvModal.hide(this.blogModal);
      this.resetForm();
    },
    editStatus(blog) {
      this.selectedBlog = blog;
      this.modalStatus = blog.status;
      this.$bvModal.show(this.blogStatusModal);
    },
    updateStatus() {
      let updates = {
        bloggerId: this.selectedBlog.blogger.bloggerId
          ? this.selectedBlog.blogger.bloggerId
          : null,
        id: this.selectedBlog.id,
        status: this.modalStatus,
        by: this.profile.userId
      };
      this.$store.dispatch("admin/updateBlogStatus", updates).then(() => {
        this.getBlogs();
        this.selectedBlog = null;
        this.modalStatus = null;
        this.$bvModal.hide(this.blogStatusModal);
      });
    },
    closeStatusModal() {
      this.selectedBlog = null;
      this.modalStatus = null;
      this.$bvModal.hide(this.blogStatusModal);
    },
    resetForm() {
      this.modalTitle = "";
      this.modalMins = 0;
      this.modalSlug = "";
      this.modalSummary = "";
      this.activeImg = null;
      this.selectedBlogId = null;
      this.selectedWpId = null;
      this.currentBlogger = null;
    },
    showDeleteBlog(blog) {
      this.edit = false;
      this.del = true;
      this.selectedBlogId = blog.id;
      this.$bvModal.show(this.blogModal);
    },
    hideDeleteBlog() {
      this.selectedBlogId = null;
      this.$bvModal.hide(this.blogModal);
    },
    deleteBlog() {
      this.$store
        .dispatch("admin/deleteBlog", {
          blogId: this.selectedBlogId,
          deletedBy: this.profile.userId
        })
        .then(res => {
          this.$bvModal.hide(this.blogModal);
          this.selectedBlogId = null;
          this.getBloggers();
        });
    }
  },
  data() {
    return {
      wordPress:{
        baseURL:'https://public-api.wordpress.com/wp/v2/sites/heartbeatfam.wordpress.com',
        pathURLPosts:'posts',
        pathURLPages:'pages',
        username:'heartbeatfamblog',
        password:'1385Spring!'
      },
      wpArticles: [],
      wpPosts: [],
      searchStr: "",
      popupText: "Copy to clipboard",
      blogModal: "edit-blog-modal",
      blogStatusModal: "edit-blog-status",
      modalTitle: "",
      modalSlug: "",
      edit: false,
      del: false,
      modalMins: 0,
      modalSummary: "",
      activeImg: null,
      stripedImages: [],
      selectedBlogId: null,
      selectedWpId: null,
      loadingwpArticles: false,
      selectedBlog: null,
      modalStatus: null,
      currentBlogger: null,
      activeCollapse: -1,
      statusOptions: [
        { value: null, text: "Please select an option" },
        { value: "submitted", text: "Submitted" },
        { value: "need_work", text: "Needs Work" },
        { value: "active", text: "Publish" },
        { value: "inactive", text: "Inactive/Remove" }
      ],
      transProps: {
        name: "flip-list"
      },
      fields: [
        { key: "Index", sortable: true, label: "Ind" },
        { key: "wordpressId", sortable: true, label: " wpId" },
        {
          key: "title",
          sortable: true,
          label: "Title",
          tdClass: "colWidth"
        },
        { key: "img", label: "Image" },
        { key: "blogger", label: "Blogger" },
        { key: "docURL", sortable: false, label: "Draft" },
        { key: "spheres", label: "Focus Areas" },
        { key: "feedback", label: "Feedback" },
        { key: "editStatus", label: "Status" },
        { key: "editBlog", label: "Actions" },
        { key: "details", label: "Details" }
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }]
    };
  }
};
</script>

<style lang="scss" scoped>
.add-users {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: #557efb;
  cursor: pointer;
  position: relative;
}
.add-user {
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-user {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.blogs {
  margin-top: 20px;
  .ico {
    cursor: pointer;
  }
  .blog-img {
    width: 150px;
  }
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
      .btn-collapse {
        padding-bottom: 0px;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
}
.post {
  cursor: pointer;
  padding: 5px 15px;
  border-bottom: 1px solid #000;
  span {
    font-weight: bold;
  }
}
.active {
  background: rgb(164, 214, 255);
}
.blog-images {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.blog-image {
  cursor: pointer;
  width: 130px;
  height: 100px;
  border-radius: 10px;
  margin: 10px 15px;
}
.active-image {
  border: 5px solid #557efb;
}
.entry {
  padding: 7px;
  .heading {
    width: 120px;
    margin-right: 15px;
    font-weight: bold;
  }
}
.article {
  display: grid;
  grid-template-columns: 198px 1fr;
  grid-column-gap: 23px;
  margin-bottom: 24px;
  align-items: stretch;
  .img-article {
    width: 198px;
    height: 100%;
    & > div {
      height: 100%;
    }
    img {
      height: 152px;
      width: 100%;
      object-fit: cover;
    }
  }
}
.article-content {
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    color: #52595e;
    margin-bottom: 8px;
  }
  .description {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #8d99a0;
    margin-bottom: 8px;
  }
  .details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    .read-more-btn {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      text-align: right;
      color: #557efb;
    }
    .categories {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      grid-column-gap: 8px;
      .read {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }
    }
  }
  .article-foot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .author {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      grid-column-gap: 12px;
      img {
        height: 32px;
        width: 32px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    .actions {
      display: flex;
      justify-content: center;
      align-items: center;
      grid-column-gap: 16px;
    }
  }
}
.tools {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-tools {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
}
.detail-tools {
  width: 370px;
  border: 1px solid #eceff9;
}
.status {
  margin-top: 0.5rem;
  .status-btn {
    display: inline-block;
    margin-right: 15px;
    width: 105px;
    height: 21px;
    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #ffffff;
    background: #557efb;
    text-align: center;
    border: none;
    border-radius: 3px;
  }
}

.actions {
  display: flex;
  justify-content: space-evenly;
}
.blogger-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
</style>
<style>
.blogs .colWidth {
  max-width: 100px;
}
</style>
